import Vue from 'vue';
import Highlight from '@/comps/highlight';
import CopyBtn from '@/comps/copy-btn';

Vue.component('mk-highlight', Highlight);
Vue.component('copy-btn', CopyBtn);
